// removed by extract-text-webpack-plugin
module.exports = {"container":"_1ozxA","body":"_3EEG5","details":"_1-YiE","start":"_1Cw8H","list":"vPr75","icon":"_3gVTk","title":"_3AUQI","short":"_3fvZV vPr75"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Categories.less
// module id = ./src/components/Home/Categories.less
// module chunks = 2